export default __webpack_public_path__ + "static/media/emailer.b1baa59f.png";